function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, AbstractConfigurablePlugin, events as events_exports } from '../core/index.module.js';
import { MathUtils } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.VisibleRangePlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var EPS = 1e-6;
var getConfig = utils_exports.getConfigParser({
  verticalRange: null,
  horizontalRange: null,
  usePanoData: false
});
var VisibleRangePlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(VisibleRangePlugin, _AbstractConfigurable);
  var _super = _createSuper(VisibleRangePlugin);
  function VisibleRangePlugin(viewer, config) {
    _classCallCheck(this, VisibleRangePlugin);
    return _super.call(this, viewer, config);
  }
  _createClass(VisibleRangePlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(VisibleRangePlugin.prototype), "init", this).call(this);
      this.autorotate = this.viewer.getPlugin("autorotate");
      this.viewer.addEventListener(events_exports.PanoramaLoadedEvent.type, this);
      this.viewer.addEventListener(events_exports.PositionUpdatedEvent.type, this);
      this.viewer.addEventListener(events_exports.ZoomUpdatedEvent.type, this);
      this.viewer.addEventListener(events_exports.BeforeAnimateEvent.type, this);
      this.viewer.addEventListener(events_exports.BeforeRotateEvent.type, this);
      this.setVerticalRange(this.config.verticalRange);
      this.setHorizontalRange(this.config.horizontalRange);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports.PanoramaLoadedEvent.type, this);
      this.viewer.removeEventListener(events_exports.PositionUpdatedEvent.type, this);
      this.viewer.removeEventListener(events_exports.ZoomUpdatedEvent.type, this);
      this.viewer.removeEventListener(events_exports.BeforeAnimateEvent.type, this);
      this.viewer.removeEventListener(events_exports.BeforeRotateEvent.type, this);
      _get(_getPrototypeOf(VisibleRangePlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case events_exports.PanoramaLoadedEvent.type:
          if (this.config.usePanoData) {
            this.setRangesFromPanoData();
          }
          break;
        case events_exports.BeforeRotateEvent.type:
        case events_exports.BeforeAnimateEvent.type:
          {
            var e2 = e;
            var _this$__applyRanges = this.__applyRanges(e2.position, e2.zoomLevel),
              rangedPosition = _this$__applyRanges.rangedPosition;
            e2.position = rangedPosition;
            break;
          }
        case events_exports.PositionUpdatedEvent.type:
          {
            var _this$autorotate;
            var currentPosition = e.position;
            var _this$__applyRanges2 = this.__applyRanges(currentPosition),
              sidesReached = _this$__applyRanges2.sidesReached,
              _rangedPosition = _this$__applyRanges2.rangedPosition;
            if ((sidesReached.left || sidesReached.right) && (_this$autorotate = this.autorotate) !== null && _this$autorotate !== void 0 && _this$autorotate.isEnabled()) {
              this.__reverseAutorotate(sidesReached.left, sidesReached.right);
            } else if (Math.abs(currentPosition.yaw - _rangedPosition.yaw) > EPS || Math.abs(currentPosition.pitch - _rangedPosition.pitch) > EPS) {
              this.viewer.dynamics.position.setValue(_rangedPosition);
            }
            break;
          }
        case events_exports.ZoomUpdatedEvent.type:
          {
            var _currentPosition = this.viewer.getPosition();
            var _this$__applyRanges3 = this.__applyRanges(_currentPosition),
              _rangedPosition2 = _this$__applyRanges3.rangedPosition;
            if (Math.abs(_currentPosition.yaw - _rangedPosition2.yaw) > EPS || Math.abs(_currentPosition.pitch - _rangedPosition2.pitch) > EPS) {
              this.viewer.dynamics.position.setValue(_rangedPosition2);
            }
            break;
          }
      }
    }
  }, {
    key: "setVerticalRange",
    value: function setVerticalRange(range) {
      if (range && range.length !== 2) {
        utils_exports.logWarn("vertical range must have exactly two elements");
        range = null;
      }
      if (range) {
        this.config.verticalRange = range.map(function (angle) {
          return utils_exports.parseAngle(angle, true);
        });
        if (this.config.verticalRange[0] > this.config.verticalRange[1]) {
          utils_exports.logWarn("vertical range values must be ordered");
          this.config.verticalRange = [this.config.verticalRange[1], this.config.verticalRange[0]];
        }
        if (this.viewer.state.ready) {
          this.viewer.rotate(this.viewer.getPosition());
        }
      } else {
        this.config.verticalRange = null;
      }
    }
  }, {
    key: "setHorizontalRange",
    value: function setHorizontalRange(range) {
      if (range && range.length !== 2) {
        utils_exports.logWarn("horizontal range must have exactly two elements");
        range = null;
      }
      if (range) {
        this.config.horizontalRange = range.map(function (angle) {
          return utils_exports.parseAngle(angle);
        });
        if (this.viewer.state.ready) {
          this.viewer.rotate(this.viewer.getPosition());
        }
      } else {
        this.config.horizontalRange = null;
      }
    }
  }, {
    key: "setRangesFromPanoData",
    value: function setRangesFromPanoData() {
      this.setVerticalRange(this.__getPanoVerticalRange());
      this.setHorizontalRange(this.__getPanoHorizontalRange());
    }
  }, {
    key: "__getPanoVerticalRange",
    value: function __getPanoVerticalRange() {
      var p = this.viewer.state.panoData;
      if (p.croppedHeight === p.fullHeight) {
        return null;
      } else {
        var getAngle = function getAngle(y) {
          return Math.PI * (1 - y / p.fullHeight) - Math.PI / 2;
        };
        return [getAngle(p.croppedY + p.croppedHeight), getAngle(p.croppedY)];
      }
    }
  }, {
    key: "__getPanoHorizontalRange",
    value: function __getPanoHorizontalRange() {
      var p = this.viewer.state.panoData;
      if (p.croppedWidth === p.fullWidth) {
        return null;
      } else {
        var getAngle = function getAngle(x) {
          return 2 * Math.PI * (x / p.fullWidth) - Math.PI;
        };
        return [getAngle(p.croppedX), getAngle(p.croppedX + p.croppedWidth)];
      }
    }
  }, {
    key: "__applyRanges",
    value: function __applyRanges() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.viewer.getPosition();
      var zoomLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.viewer.getZoomLevel();
      var rangedPosition = {
        yaw: position.yaw,
        pitch: position.pitch
      };
      var sidesReached = {};
      var vFov = this.viewer.dataHelper.zoomLevelToFov(zoomLevel);
      var hFov = this.viewer.dataHelper.vFovToHFov(vFov);
      if (this.config.horizontalRange) {
        var range = utils_exports.clone(this.config.horizontalRange);
        var offset = MathUtils.degToRad(hFov) / 2;
        range[0] = utils_exports.parseAngle(range[0] + offset);
        range[1] = utils_exports.parseAngle(range[1] - offset);
        if (range[0] > range[1]) {
          if (position.yaw > range[1] && position.yaw < range[0]) {
            if (position.yaw > range[0] / 2 + range[1] / 2) {
              rangedPosition.yaw = range[0];
              sidesReached.left = true;
            } else {
              rangedPosition.yaw = range[1];
              sidesReached.right = true;
            }
          }
        } else if (position.yaw < range[0]) {
          rangedPosition.yaw = range[0];
          sidesReached.left = true;
        } else if (position.yaw > range[1]) {
          rangedPosition.yaw = range[1];
          sidesReached.right = true;
        }
      }
      if (this.config.verticalRange) {
        var _range = utils_exports.clone(this.config.verticalRange);
        var _offset = MathUtils.degToRad(vFov) / 2;
        _range[0] = utils_exports.parseAngle(_range[0] + _offset, true);
        _range[1] = utils_exports.parseAngle(_range[1] - _offset, true);
        if (_range[0] > _range[1]) {
          _range[0] = (_range[0] + _range[1]) / 2;
          _range[1] = _range[0];
        }
        if (position.pitch < _range[0]) {
          rangedPosition.pitch = _range[0];
          sidesReached.bottom = true;
        } else if (position.pitch > _range[1]) {
          rangedPosition.pitch = _range[1];
          sidesReached.top = true;
        }
      }
      return {
        rangedPosition: rangedPosition,
        sidesReached: sidesReached
      };
    }
  }, {
    key: "__reverseAutorotate",
    value: function __reverseAutorotate(left, right) {
      if (left && this.autorotate.config.autorotateSpeed > 0 || right && this.autorotate.config.autorotateSpeed < 0) {
        return;
      }
      this.autorotate.reverse();
    }
  }]);
  return VisibleRangePlugin;
}(AbstractConfigurablePlugin);
VisibleRangePlugin.id = "visible-range";
VisibleRangePlugin.configParser = getConfig;
VisibleRangePlugin.readonlyOptions = ["horizontalRange", "verticalRange"];
export { VisibleRangePlugin };
//# sourceMappingURL=index.module.js.map
